import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { useApp } from "../../app/Application.provider";
import { SAFE_FALLBACK_ROUTE } from "../../auth/constants";

export const Route = createFileRoute("/auth/success")({
  component: SuccessPage,
});

// Stable success landing when auth completes with no encoded redirect target.
// Auto-redirects to the dashboard after a short delay so the user sees confirmation.
function SuccessPage() {
  const { auth } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      void navigate({ to: SAFE_FALLBACK_ROUTE as string, replace: true });
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <p style={{ fontSize: "1.25rem", fontWeight: 600, color: "#111827" }}>
        Signed in successfully
      </p>
      {auth.user?.name && (
        <p style={{ color: "#6b7280", marginTop: "0.5rem" }}>Welcome, {auth.user.name}.</p>
      )}
      <p style={{ color: "#9ca3af", fontSize: "0.75rem", marginTop: "1rem" }}>
        Redirecting to your dashboard…
      </p>
    </div>
  );
}
